import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal, Select } from "antd";
import { API_CREATE_STORE } from "api/store-managemnt";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import axios, { Axios } from "axios";
import { CONSTANTS } from "config/constant";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import { API_UPDATE_STORE } from "api/store-managemnt";
import { useTranslation } from "react-i18next";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import PhoneInput from "react-phone-input-2";
import { MdOutlineArrowBack } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { Option } from "antd/es/mentions";
import { API_GET_STORE } from "api/store-managemnt";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { API_UPLOAD_IMAGE } from "api/user-mangement";
import { API_UPLOAD_IMAGE_STORE } from "api/store-managemnt";
const EditStore = () => {
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const { t } = useTranslation();
  const [datas, setDatas] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // State to hold the selected option
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const location = useLocation();
  const Navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // Adjust the page size according to your needs
    totalPages: 1, // Initialize totalPages with 1
  });
  const [loading, setLoading] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  // const [data, setData] = useState();
  const [loadingGet, setLoadingGet] = useState();

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();

  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: CONSTANTS?.BACKEND_URL + data?.profile_image?.[0]?.file_url,
    // },
  ]);
  let { id } = useParams();
  const selectRef = useRef(null);

  const data = location.state && location.state.data;
  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    try {
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`
      );
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedAddress.place_id}&key=${CONSTANTS?.googleApikey}`
        // `${CONSTANTS.BACKEND_URL}api/public/google/place-details?place_id=${selectedAddress.place_id}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`
      );
      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", postalCode);
        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue("location", selectedAddress?.description);

        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);

        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  const fetchData = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_MAIN_LAUNDRY(params);
      setDatas((prevData) => [...prevData, ...newData.laundry]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.totalPages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // const fetchDataStore = async () => {
  //   setLoadingGet(true);
  //   try {
  //     const newData = await API_GET_STORE(id);
  //     console.log("provider", newData);
  //     setData(newData?.provider);
  //     setLoadingGet(false);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoadingGet(false);
  //   }
  // };

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };

  // useEffect(() => {
  //   fetchDataStore();
  // }, [id]);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (!newFileList?.length > 0) {
      setImage("");
    }
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_IMAGE_STORE(formData);

      console.log("result", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList);
      setFileList(newFileList);
      setImage(response?.file);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("Upload")}
      </div>
    </button>
  );

  useEffect(() => {
    fetchData(pagination.current);
  }, [pagination.current]);

  useEffect(() => {
    const newData = [data?.laundry_info];
    // setDatas(newData);
    // If there's a pre-selected laundry option available in data, set it as the selected option
    const preSelectedOption = newData?.find(
      (option) => option?._id === data?.laundry_info?._id
    );
    if (preSelectedOption) {
      console.log("preSelectedOption", preSelectedOption);
      setSelectedOption(preSelectedOption);
    }
  }, []);
  useEffect(() => {
    if (data?.profile_image?.[0]?.file_url) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: data?.profile_image?.[0]?.file_url
            ? CONSTANTS?.IMG_DIRECTORY + data?.profile_image?.[0]?.file_url
            : "",
        },
      ]);
      setImage(data?.profile_image);
    }
  }, []);

  // Working previoies
  // const fetchData = async (page) => {
  //   try {
  //     setLoading(true);
  //     const params = {
  //       page: page,
  //       limit: pagination.pageSize,
  //       name: "",
  //     };
  //     const newData = await API_LIST_MAIN_LAUNDRY(params);
  //     setDatas((prevData) => [...prevData, ...newData.laundry]);
  //     setPagination((prevPagination) => ({
  //       ...prevPagination,
  //       totalPages: newData.totalPages,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const handleOptionChange = (event) => {
  //   const selectedLaundryId = event.target.value;
  //   const selectedOption = datas.find(
  //     (option) => option._id === selectedLaundryId
  //   );
  //   console.log("selectedLaundryId", selectedLaundryId);
  //   setSelectedOption(selectedLaundryId);

  //   if (selectedLaundryId === "__load_more__") {
  //     handleLoadMore();
  //     setSelectedOption("");
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   const newData = [data?.laundry_info];
  //   setDatas(newData);

  //   // If there's a pre-selected laundry option available in data, set it as the selected option
  //   const preSelectedOption = newData.find(
  //     (option) => option._id === data?.laundry_info?._id
  //   );
  //   if (preSelectedOption) {
  //     setSelectedOption(preSelectedOption);
  //   }
  // }, []);
  // console.log("data==>", data);

  // const handleLoadMore = () => {
  //   const nextPage = pagination.current + 1;
  //   fetchData(nextPage);
  //   setPagination((prevPagination) => ({
  //     ...prevPagination,
  //     current: nextPage,
  //   }));
  // };

  // const handleScroll = () => {
  //   const { scrollTop, clientHeight, scrollHeight } = selectRef.current;
  //   if (scrollHeight - scrollTop === clientHeight) {
  //     setScrolling(true);
  //   }
  // };
  console.log("selected", data);
  console.log("image====>", image, fileList);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            enableReinitialize
            initialValues={{
              store_name: data?.store_name,
              description: data?.description,
              // laundry: selectedOption?._id,
              laundry: "66a36f36a8b7d2b43551a939",
              location: data?.address,
              // address:data?.address,
              location_lat: data?.geo?.coordinates[0],
              location_lng: data?.geo?.coordinates[1],
              geo: data?.geo,
              password: data?.password,
              email: data?.email,
              phone_no: data?.phone_no,
              address: data?.location?.address,
              store_owner_first_name: data?.store_owner_info?.[0]?.first_name,
              store_owner_last_name: data?.store_owner_info?.[0]?.last_name,
              store_owner_email: data?.store_owner_info?.[0]?.email,
              store_owner_phone_no: data?.store_owner_info?.[0]?.phone_no,
            }}
            validationSchema={Yup.object({
              store_name: Yup.string().required("Required"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              password: Yup.string().required("Required"),
              phone_no: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),

              // .matches(/^[0-9]+$/, "Phone number must contain only numbers")
              // .max(12, "Phone number must be at most 12 characters long"),

              // laundry: Yup.string().required("Required"),
              location: Yup.string().required("Required"),
              store_owner_first_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              store_owner_last_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              store_owner_email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              store_owner_phone_no: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),

              // .matches(/^[0-9]+$/, "Phone number must contain only numbers")
              // .max(12, "Phone number must be at most 12 characters long"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              setValuesData(values);
              setConfirmModalVisible(true);
              // try {
              //   const {
              //     store_owner_first_name,
              //     store_owner_last_name,
              //     store_owner_email,
              //     store_owner_phone_no,
              //     location,
              //     address,
              //     laundry,
              //     location_lat,
              //     location_lng,
              //     password,
              //     ...storeData
              //   } = values;

              //   const storeOwnerInfo = {
              //     first_name: store_owner_first_name,
              //     last_name: store_owner_last_name,
              //     email: store_owner_email,
              //     phone_no: store_owner_phone_no,
              //   };
              //   const latLng = `${location_lat},${location_lng}`;

              //   const payload = {
              //     ...storeData,
              //     laundry: selectedOption,
              //     location: {
              //       lat_long: latLng,
              //       address: location,
              //     },
              //     store_owner_info: storeOwnerInfo,
              //   };

              //   const userData = await API_UPDATE_STORE(payload, data?._id);
              //   toast.success(userData?.message);
              //   Navigate("/admin/store-management/store-tables");
              // } catch (error) {
              //   console.error("error", error);
              //   toast.error(error?.response?.data?.message);
              // } finally {
              //   setSubmitting(false);
              // }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div
                  className="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>
                <div className="mb-3 flex justify-center">
                  <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-circle"
                    customRequest={customRequest}
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                  >
                    {fileList.length == 1 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </div>
                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  {t("Store Owner")}
                </h1>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("First Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("First Name")}
                      </label> */}
                      {console.log(values, "valuesssss")}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="store_owner_first_name"
                        placeholder={t("First Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="store_owner_first_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Last Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Last name")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="store_owner_last_name"
                        placeholder="Last name"
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="store_owner_last_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Email")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Email")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="store_owner_email"
                        placeholder={t("Email")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="store_owner_email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      <PhoneInput
                        disableDropdown={true}
                        country={"sa"}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        // className="w-100 mt-2"
                        inputClass="w-full "
                        // inputClass="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        inputProps={{
                          className:
                            "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500 pl-[3rem]",

                          name: "store_owner_phone_no",
                          placeholder: "Phone No",
                          onKeyPress: (e) => {
                            const currentValue =
                              values?.store_owner_phone_no || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.store_owner_phone_no}
                        onChange={(value) => {
                          setFieldValue("store_owner_phone_no", value);
                        }}
                        // style={{ Width: "100%", height: "2.7rem" }}
                      />
                      <ErrorMessage
                        name="store_owner_phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>

                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  {t("Store")}
                </h1>

                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Store Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store Name")}
                      </label> */}
                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="store_name"
                        placeholder={t("Store Name")}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                        onInput={(event) => {
                          const value = event.target.value;
                          const wordCount = value?.trim()?.split(/\s+/).length;
                          if (wordCount > 5) {
                            const words = value
                              ?.trim()
                              ?.split(/\s+/)
                              ?.slice(0, 5)
                              ?.join(" ");
                            event.target.value = words;
                          }
                        }}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="store_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      <PhoneInput
                        disableDropdown={true}
                        country={"sa"}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        // className="w-100 mt-2"
                        inputProps={{
                          className:
                            "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500  pl-[3rem]",

                          name: "phone_no",
                          placeholder: "Phone No",

                          onKeyPress: (e) => {
                            const currentValue = values?.phone_no || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.phone_no}
                        onChange={(value) => {
                          setFieldValue("phone_no", value);
                        }}
                      />
                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* <Col span={8}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {t("Store Password")}
                        <span className="text-[red]">*</span>
                      </label>
       
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Store Password")}

                        // autoComplete="off"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Store Email")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store Email")}
                      </label> */}

                      {console.log(image, "iamtheimagesssnextgen")}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Store Email")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Select Laundry")}
                        <span className="text-[red]">*</span>
                      </label> */}
                  {/* <select
                        ref={selectRef}
                        className="select mt-2 flex h-11 w-full items-center justify-center overflow-y-auto rounded-xl border bg-white p-3 text-sm outline-none"
                        onChange={handleOptionChange}
                        name="laundry"
                        value={selectedOption?._id}
                        onScroll={handleScroll}
                      >
                        <option value="">Select a laundry option</option>
                        {datas.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.laundry_name}
                          </option>
                        ))}
                        {pagination.current < pagination.totalPages &&
                          !loading && (
                            <option
                              key="loadMoreOption"
                              value="__load_more__"
                              style={{ background: "gray", color: "white" }}
                            >
                              Load More
                            </option>
                          )}
                      </select> */}
                  {/* {pagination.current < pagination.totalPages && (
                        <div style={{ textAlign: "center" }}>
                          {loading ? (
                            <span>Loading...</span>
                          ) : (
                            <button onClick={handleLoadMore}>Load More</button>
                          )}
                        </div>
                      )} */}
                  {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Select Laundry")}
                      </label> */}

                  {/*.....................working............... */}
                  {/* <Field name="laundry">
                        {({ field }) => (
                          <Select
                            // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                            className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                            {...field}
                            showSearch
                            placeholder="Select Laundry"
                            optionFilterProp="children"
                            onPopupScroll={handleScroll}
                            // value={selectedOption}
                            value={
                              selectedOption
                                ? selectedOption.laundry_name
                                : undefined
                            }
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            loading={loading}
                            onChange={(value) => {
                              const selected = datas?.find(
                                (item) => item._id === value
                              );
                              console.log("selected ==>", selected);
                              setSelectedOption(selected);
                              setFieldValue("laundry", selected?._id);
                              // setFieldValue("laundry", value);
                              // setTouched({ laundry: true });
                            }}
                          >
                            {datas?.map((item) => (
                              <Option key={item._id} value={item._id}>
                                {item.laundry_name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Field>

                      <ErrorMessage
                        name="laundry"
                        component="div"
                        className="text-red-500"
                      /> */}

                  {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                        as="select"
                        name="laundry"
                        // disabled={true}
                      >
                        {datas?.map((value, index) => {
                          return (
                            // <option value={(value?.name, value?._id)}>
                            <option
                              key={value?._id}
                              value={value?._id}
                              selected={value?._id === data?.laundry_info?._id}
                            >
                              {value?.laundry_name}
                            </option>
                          );
                        })}
                      </Field> */}
                  {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                        as="select"
                        name="laundry"
                        disabled={true}
                      >
                        <option value="Driver">Driver</option>
                        <option value="User">User</option>
                        <option value="Laundry Men">Laundry Men</option>
                      </Field> */}
                  {/* </div>{" "}
                  </Col> */}
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Store description")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store description")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 min-h-20 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Store description")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col xs={24} md={12} lg={16} className="">
                    {/* <label
                      for="floating_outlined"
                      className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                    >
                      {t("Store Name")}
                    </label> */}
                    <TextareaField
                      // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                      className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      label={t("Location")}
                      name="location"
                      placeholder={t("Location")}
                      value={values?.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue("location", addressInput);
                        searchAddress(addressInput); // Call the address autocomplete function
                      }}
                      // required
                    />
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestions.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestions}
                        // onSelectAddress={onSelectAddress}
                        onSelectAddress={(address) =>
                          onSelectAddress(address, setFieldValue)
                        }
                      />
                    )}
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {/* {isSubmitting ? "Updating..." : " Update Store"}{" "} */}
                    {isSubmitting ? t("Updating") + "..." : t("Update Store")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            // title="Save Changes"
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
            onOk={async () => {
              setConfirmModalVisible(false);
              try {
                const {
                  store_owner_first_name,
                  store_owner_last_name,
                  store_owner_email,
                  store_owner_phone_no,
                  location,
                  address,
                  laundry,
                  location_lat,
                  location_lng,
                  password,
                  geo,
                  ...storeData
                } = valuesData;

                const storeOwnerInfo = {
                  first_name: store_owner_first_name,
                  last_name: store_owner_last_name,
                  email: store_owner_email,
                  phone_no: store_owner_phone_no,
                };
                const latLng = `${location_lat},${location_lng}`;
                const payload = {
                  ...storeData,
                  laundry: selectedOption?._id,
                  location: {
                    lat_long: latLng,
                    address: location,
                  },
                  address: location?.address,
                  geo: geo,
                  store_owner_info: storeOwnerInfo,
                  profile_image: image,
                };
                // console.log(payload,'payloaddssss')
                const userData = await API_UPDATE_STORE(payload, data?._id);
                toast.success(userData?.message);
                Navigate("/admin/store-management/store-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                // setSubmitting(false);
              }
            }}
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">{t("Save Changes")}</p>
                <p className="mb-8 font-medium">
                  {t("Do you want to Save Changes before leaving the Page?")}
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  {t("Cancel")}
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    setConfirmModalVisible(false);
                    try {
                      const {
                        store_owner_first_name,
                        store_owner_last_name,
                        store_owner_email,
                        store_owner_phone_no,
                        location,
                        address,
                        laundry,
                        location_lat,
                        location_lng,
                        password,
                        geo,
                        ...storeData
                      } = valuesData;
                      const storeOwnerInfo = {
                        first_name: store_owner_first_name,
                        last_name: store_owner_last_name,
                        email: store_owner_email,
                        phone_no: store_owner_phone_no,
                      };
                      const latLng = `${location_lat},${location_lng}`;
                      const payload = {
                        ...storeData,
                        laundry: selectedOption?._id,
                        // location: {
                        //   lat_long: latLng,
                        //   address: location,
                        // },
                        location: {
                          coordinates: [location_lat, location_lng],
                          // address: location,
                        },
                        address: address,
                        geo: geo,
                        store_owner_info: storeOwnerInfo,
                        profile_image: image ? image : [],
                      };
                      const userData = await API_UPDATE_STORE(
                        payload,
                        data?._id
                      );
                      toast.success(userData?.message);
                      Navigate("/admin/store-management/store-tables");
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    } finally {
                      // setSubmitting(false);
                    }
                  }}
                >
                  {t("Save Changes")}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditStore;
